import { useField } from '@oneform/react';
import { Children, cloneElement, memo, useCallback, useMemo, } from 'react';
const MintedSelectCustomField = ({ children, getSelectedOption = () => { }, getSelectedText = () => { }, }) => {
    const { name, onBlur: onVisit, onChange = () => { }, } = (
    // @ts-ignore 2339
    children.props);
    const { errorMessages, fieldName, isChecked, isVisited, updateFieldValue, value, visitField, } = (useField({
        inputValue: undefined,
        isCheckboxElement: false,
        isMultipleElement: false,
        name,
        onChange,
        // @ts-ignore 2322
        onVisit,
    }));
    const selectedOption = (useMemo(() => ({
        option: (getSelectedOption(value)),
        text: (getSelectedText(value)),
        value,
    }), [
        getSelectedOption,
        getSelectedText,
        value,
    ]));
    const updateSelectedValue = (useCallback((localSelectedOption) => {
        updateFieldValue({
            target: {
                value: (localSelectedOption === null || localSelectedOption === void 0 ? void 0 : localSelectedOption.value),
            },
        });
        onChange(localSelectedOption);
    }, [
        onChange,
        updateFieldValue,
    ]));
    const childProps = (useMemo(() => ({
        checked: isChecked,
        error: (typeof errorMessages[0] === 'string'
            ? errorMessages[0]
            : (errorMessages[0]
                ? ' '
                : '')),
        name: fieldName,
        onBlur: visitField,
        onChange: updateSelectedValue,
        selectedOption,
        touched: isVisited,
    }), [
        errorMessages,
        fieldName,
        isChecked,
        isVisited,
        selectedOption,
        updateSelectedValue,
        visitField,
    ]));
    return (cloneElement((Children
        .only(children)), childProps));
};
const MemoizedMintedSelectCustomField = memo(MintedSelectCustomField);
export { MemoizedMintedSelectCustomField as MintedSelectCustomField };
